import { parse } from 'query-string'

export const getSearchParams = () => {
  return parse(window.location.search.replace('?', ''))
}
